import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchReceiptDocumentDescriptions(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get('/receipt-document-descriptions', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addReceiptDocumentDescription(ctx, receiptDocumentDescriptionData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('/receipt-document-descriptions', receiptDocumentDescriptionData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchReceiptDocumentDescription(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/receipt-document-descriptions/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateReceiptDocumentDescription(ctx, { id, receiptDocumentDescriptionData }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`/receipt-document-descriptions/${id}`, receiptDocumentDescriptionData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteReceiptDocumentDescription(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`/receipt-document-descriptions/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
